/** Lowercase ISO 4217 (the Stripe/DB convention); display sites uppercase explicitly where needed. */
export const DEFAULT_CURRENCY = 'eur';

/** Maximum length for the invoice note shown as its description and custom field value. */
export const INVOICE_DESCRIPTION_MAX_LENGTH = 140;

/** Maximum length for a customer-facing billing coupon name. */
export const BILLING_COUPON_NAME_MAX_LENGTH = 40;

export const BILLING_INVOICE_ADDRESS_LIMITS = {
  name: 255,
  line1: 255,
  city: 120,
  postalCode: 40,
  vatId: 40,
  notes: INVOICE_DESCRIPTION_MAX_LENGTH,
} as const;

export const MAX_SEAT_QUANTITY = 10000;
export const MIN_TEAM_QUANTITY = 1;
export const TEAM_QUANTITY_STEP = 1;
export const MIN_STUDENT_QUANTITY = 15;
export const STUDENT_QUANTITY_STEP = 5;
